import { FC } from "react";

import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

interface BorderTopIconProps {
  children: string;
}

const BorderTopIcon: FC<BorderTopIconProps> = ({ children }) => (
  <>
    <Typography
      variant="h2"
      component="span"
      sx={{
        position: "absolute",
        bottom: "100%",
        right: 0,
        fontSize: { xs: 12, md: 18, lg: 22, xl: 28 },
        fontWeight: 800,
      }}
    >
      {children}
    </Typography>
    <Box
      component="svg"
      width="319"
      height="71"
      viewBox="0 0 319 71"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      sx={{
        height: "auto",
        width: "100%",
      }}
    >
      <path
        d="M318.953 2.98633 H67.9531L1.95312 68.9863"
        stroke="white"
        strokeWidth="4"
      />
    </Box>
  </>
);

export default BorderTopIcon;
